import styled from 'styled-components';

export const SelectionOptionsDescription = styled.span`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.body};
  font-weight: ${Styles.fontWeight.normal};
  font-size: 0.8125rem;
  padding-left: 1rem;
`;
